import { Order, orderFromJSONLegacy } from '@exodus/models'

export const isOrderSupported = ({ order, assets }) =>
  !!order.fromAmount && !!order.toAmount && !!assets[order.fromAsset] && !!assets[order.toAsset] // some dev-created orders may not have these fields.

export const isOrderMetadataValid = (order) => {
  return Array.isArray(order.txIds) && typeof order.txIds[0] === 'object'
}

export const convertLegacyOrderMetadata = (order) => {
  if (typeof order.txIds?.[0] === 'string') {
    return order.update({ txIds: order.txIds.map((txId) => ({ txId, txType: 'swapTransaction' })) })
  }

  return order.update({
    txIds: [
      { txId: order.fromTxId, txType: 'depositTransaction' },
      { txId: order.toTxId, txType: 'withdrawalTransaction' },
    ],
  })
}

export const parseOrder = ({ order, assets, logger }) => {
  try {
    return order._version ? Order.fromJSON(order) : orderFromJSONLegacy(order, { assets })
  } catch (error) {
    logger.error('Failed to parse order', order, error)
  }
}
